export const fetchUserRecords = (users) => {
  // Return action
  return {
    // Unique identifier
    type: 'GET_USERS',
	users: users
  }
};
